<script setup lang="ts">
/**
 * Сравнение «до и после» внутри черновика (макет 8-4).
 *
 * Отдельным компонентом, потому что мест два: черновик крупного действия в
 * панели и инлайн-помощь редактора (DEV-1578). Второй набор такой же вёрстки
 * рядом разъехался бы с первым на первой же правке стилей, а человек читает
 * одно и то же сравнение в обоих местах.
 */
import type { DiffLine } from './draft'

defineProps<{ hunks: DiffLine[][] }>()

const sign = (item: DiffLine) => (item.added ? '+' : '-')
</script>

<template>
  <div class="ddiff">
    <div v-for="(hunk, index) in hunks" :key="index" class="ddiff__hunk">
      <p
        v-for="(item, position) in hunk"
        :key="position"
        class="ddiff__line"
        :class="item.added ? 'ddiff__line--added' : 'ddiff__line--removed'"
      >
        <span class="ddiff__sign" aria-hidden="true">{{ sign(item) }}</span>
        <span class="ddiff__text">{{ item.text }}</span>
      </p>
    </div>
  </div>
</template>

<style scoped>
.ddiff {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
}

.ddiff__line {
  display: flex;
  gap: 8px;
  margin: 0;
  padding: 3px 10px;
  font-size: var(--font-size-body-sm);
  line-height: 18px;
}

.ddiff__line--removed {
  background: var(--color-danger-tint);
  color: var(--color-text-muted);
}

.ddiff__line--added {
  background: var(--color-success-tint);
  color: var(--color-text-primary);
}

.ddiff__sign {
  flex-shrink: 0;
  width: 8px;
  font-family: var(--font-family-mono);
  line-height: 20px;
}

.ddiff__line--removed .ddiff__sign {
  color: var(--color-danger-strong);
}

.ddiff__line--added .ddiff__sign {
  color: var(--color-success-strong);
}

.ddiff__text {
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
</style>
